import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
  root: {
    position: 'relative',
    zIndex: -1
  },
  driverContainer: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    top: -28,
    left: -62,
    width: 124,
    transition: '200ms',
    transform: 'translate3d(0,0,0)',
    pointerEvents: 'none'
  },
  driverContainerExpanded: {
    opacity: 0,
    transition: '200ms',
    transform: 'translate3d(0,12px,0)',
  },
  driver: {
    background: 'black',
    color: 'white',
    padding: 4,
    paddingLeft: 6,
    paddingRight: 6,
    borderRadius: 3
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/map-markers/live-location-marker-styles.js